var map = {
	"./app_logo.png": "beb3",
	"./app_qrcode.png": "158b",
	"./cover_bg.png": "7f0c",
	"./icon_add_money.png": "607d",
	"./icon_add_person.png": "8da4",
	"./icon_apartment.png": "241d",
	"./icon_bind.png": "b97d",
	"./icon_check_in.png": "e812",
	"./icon_device_manager.png": "6d38",
	"./icon_download.png": "a8bf",
	"./icon_homestay.png": "0ad5",
	"./icon_online_room.png": "4281",
	"./icon_order_manager.png": "bf4b",
	"./icon_room_manager.png": "89be",
	"./icon_room_status.png": "66cf",
	"./icon_small_hotel.png": "ed6d",
	"./icon_staff_management.png": "a593",
	"./icon_triangle_right.png": "ccc9",
	"./industry_1.png": "7698",
	"./industry_2.png": "fbf3",
	"./industry_3.png": "9281",
	"./industry_4.png": "2045",
	"./logo.png": "ab38",
	"./phone.png": "1c9a",
	"./process_bg.png": "6fb7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fdc6";